import { Button, Img, Input, MobileInput, Text, AutoFillAddress } from "components";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import globalRequest from "../../../../utils/global/globalRequest";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../../../redux/reducers/loader";
import * as API from "../../../../utils/helper/Enum";
import { setSnackbar } from "../../../../redux/reducers/snackbar";
import * as CUSTOM from "../../../../utils/helper/custom";
import {
  getGiftOrderData,
  updateGiftOrderData,
} from "../../../../redux/reducers/giftOrderData";
import {
  validateForm,
  strFormat,
  defaultAddressParams,
} from "../../../../utils/helper/custom";
import {
  updateMyAddress,
  getAddressData,
} from "../../../../redux/reducers/myAddress";

const StepsDeliveryAddress = ({ orderDetails }) => {
  const { t } = useTranslation();
  let dispatch = useDispatch();
  let orderData = useSelector(getGiftOrderData);
  const getAddress = useSelector(getAddressData);
  const [errors, setErrors] = useState({});

  // Initialize address data on mount
  useEffect(() => {
    let dAddress = defaultAddressParams();
    if (orderData?.addressData) {
      dAddress = orderData?.addressData;
    }
    dAddress = {
      ...dAddress,
      full_name: orderData?.orderDetails?.giftDetails?.recipient_name,
      mobile_no: CUSTOM?.getMobileNo(orderData?.orderDetails?.giftDetails?.mobile_no, "number"),
    };
    dispatch(updateMyAddress(dAddress));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Auto-fill address_label when a new location is selected from map
   * Takes the first meaningful part of the address string (before first comma)
   */
  // useEffect(() => {
  //   if (getAddress?.address && !getAddress?.address_label) {
  //     const firstPart = getAddress.address.split(",")[0]?.trim() || "";
  //     dispatch(updateMyAddress({ ...getAddress, address_label: firstPart }));
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [getAddress?.address]);

  /**
   * Validate and save address data, then check zone
   */
  const saveAddress = async (e) => {
    e.preventDefault();
    let validationErrors = validateForm(getAddress, "addAddress", t);
    let validateMobile = CUSTOM.isValidMobile(getAddress?.mobile_no, t);
    validationErrors = { ...validationErrors, ...validateMobile };
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      dispatch(changeLoader(true));
      try {
        let response = await globalRequest(
          `${API.GIFTORDER.CHECK_ADDRESS_IN_ZONE}`,
          "post",
          {
            lattitude: getAddress?.lattitude,
            longitude: getAddress?.longitude,
          },
          {},
          true
        );
        response = response?.data;
        if (response?.status == "SUCCESS") {
          let addressData = {
            streetNumber: getAddress?.street_number,
            buildingNumber: getAddress?.building_number,
            floorApartment: getAddress?.floor_apartment,
            address: getAddress?.formatted_address || getAddress?.address,
            lattitude: getAddress?.lattitude,
            longitude: getAddress?.longitude,
            is_save: true,
          };
          dispatch(
            updateGiftOrderData({
              ...orderData,
              addressData: addressData,
              pageStep: 3,
            })
          );
        } else {
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: response?.message,
              snackbarState: "error",
            })
          );
        }
      } catch (e) {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: e?.message,
            snackbarState: "error",
          })
        );
      }
      dispatch(changeLoader(false));
    }
  };

  return (
    <div className="relative flex flex-col w-full">
      {/* Section Header */}
      <div className="mb-5">
        <Text
          className="text-[24px] leading-[32px]"
          style={{
            color: "var(--Blacks-900, #1A1A1A)",
            fontFamily: "Unbounded",
            fontStyle: "normal",
            fontWeight: "500",
          }}
        >
          {t("deliveryAddress")}
        </Text>
        {/* <Text className="text-gray-500 text-sm font-nunitoregular mt-0.5">
          {t("forYourGiftAddDeliveryAddress")}
        </Text> */}
      </div>

      {/* Inline Address Form - matches image 3 layout */}
      {Object.keys(getAddress).length > 0 && (
        <form onSubmit={saveAddress} className="w-full flex flex-col gap-0">

          {/* Map / AutoFill Section */}
          <div className="w-full rounded-xl overflow-hidden mb-4 border border-gray-100"
               style={{ height: "350px" }}>
            <AutoFillAddress />
          </div>

          {/* Selected address display */}
          {getAddress?.address ? (
            <div className="flex flex-row items-start gap-2 mb-4 px-1">
              <Img src="/images/location_on_black.svg" className="h-4 w-4 mt-0.5 flex-shrink-0" alt="loc" />
              <span className="text-sm text-gray-700 font-nunitoregular leading-relaxed">
                {getAddress?.address}
              </span>
            </div>
          ) : (
            <div className="flex flex-row items-center gap-2 mb-4 px-1 text-gray-400 text-sm">
              <Img src="/images/location_on_black.svg" className="h-4 w-4 flex-shrink-0 opacity-40" alt="loc" />
              <span className="font-nunitoregular">{t("searchForLocation")}</span>
            </div>
          )}

          <div className="mb-3">
            <label className="block mb-1"
  style={{
    color: "var(--Blacks-300, #6D737E)",
    fontFamily: "Inter",
    fontSize: "var(--Font-size-medium, 14px)",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "var(--Font-Line-height-10-14, 16px)",
  }}>
              Address Label
            </label>

            <Input
              className="w-full error-fixed"
              placeholder={t("addressPlaceholder")}
              value={getAddress?.address_label || ""}
              onChange={(e) => {
                dispatch(
                  updateMyAddress({
                    ...getAddress,
                    address_label: strFormat(e.target.value, "max:50"),
                  })
                );
              }}
            />
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-1 gap-x-4 mb-3">
  
  <div>
    <label className="block mb-1"
  style={{
    color: "var(--Blacks-300, #6D737E)",
    fontFamily: "Inter",
    fontSize: "var(--Font-size-medium, 14px)",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "var(--Font-Line-height-10-14, 16px)",
  }}>
      {t("streetAddress")}*
    </label>
    <Input
      className="w-full error-fixed"
      placeholder={t("enterStreetAddress")}
      error={errors?.street_number}
      value={getAddress?.street_number}
      onChange={(e) => {
        setErrors({ ...errors, street_number: "" });
        dispatch(
          updateMyAddress({
            ...getAddress,
            street_number: strFormat(e.target.value, "max:50"),
          })
        );
      }}
    />
  </div>

  <div>
    <label className="block mb-1"
  style={{
    color: "var(--Blacks-300, #6D737E)",
    fontFamily: "Inter",
    fontSize: "var(--Font-size-medium, 14px)",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "var(--Font-Line-height-10-14, 16px)",
  }}>
      {t("streetNumber")}*
    </label>
    <Input
      className="w-full error-fixed"
      placeholder={t("enterStreetNumber")}
      error={errors?.street_number}
      value={getAddress?.street_number_alt || ""}
      onChange={(e) => {
        setErrors({ ...errors, street_number: "" });
        dispatch(
          updateMyAddress({
            ...getAddress,
            street_number_alt: strFormat(e.target.value, "max:50"),
          })
        );
      }}
    />
  </div>

</div>

          <div className="grid grid-cols-2 sm:grid-cols-1 gap-x-4 mb-3">
  
  <div>
    <label className="block mb-1"
  style={{
    color: "var(--Blacks-300, #6D737E)",
    fontFamily: "Inter",
    fontSize: "var(--Font-size-medium, 14px)",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "var(--Font-Line-height-10-14, 16px)",
  }}>
      {t("buildingNumber")}*
    </label>
    <Input
      className="w-full error-fixed"
      placeholder={t("enterBuildingNumber")}
      error={errors?.building_number}
      value={getAddress?.building_number}
      onChange={(e) => {
        setErrors({ ...errors, building_number: "" });
        dispatch(
          updateMyAddress({
            ...getAddress,
            building_number: strFormat(e.target.value, "max:50"),
          })
        );
      }}
    />
  </div>

  <div>
    <label className="block mb-1"
      style={{
        color: "var(--Blacks-300, #6D737E)",
        fontFamily: "Inter",
        fontSize: "var(--Font-size-medium, 14px)",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "var(--Font-Line-height-10-14, 16px)",
      }}>
      {t("floor_Apartment")}*
    </label>
    <Input
      className="w-full error-fixed"
      placeholder={t("enterFloorNumber")}
      error={errors?.floor_apartment}
      value={getAddress?.floor_apartment}
      onChange={(e) => {
        setErrors({ ...errors, floor_apartment: "" });
        dispatch(
          updateMyAddress({
            ...getAddress,
            floor_apartment: strFormat(e.target.value, "max:50"),
          })
        );
      }}
    />
  </div>

</div>

          {/* Continue Button */}
          <div className="w-full mt-4 mb-2">
            <button
              type="submit"
              className={`w-full py-4 rounded-full transition-all duration-200
                ${!getAddress?.lattitude
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-[#771237] hover:bg-[#771237] shadow-md hover:shadow-lg"
                }`}
              style={{
                color: "var(--Disabled-SubText, #F1E4EA)",
                textAlign: "center",
                fontFamily: "Unbounded",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "24px",
              }}
              disabled={!getAddress?.lattitude}
            >
              {t("continue")}
            </button>
          </div>
        </form>
      )}

      {/* 
        {addressPopup ? (
          <AddEditAddress
            setInputData={setInputData}
            orderData={orderDetails}
            giftorderData={orderData}
            setAddAddressPopup={setAddAddressPopup}
            pageName={"recipientForm"}
          />
        ) : null}
      */}
    </div>
  );
};

export default StepsDeliveryAddress;